<!-- src/app/pages/home/home.component.html -->

<!-- ── HERO ──────────────────────────────────────────────────────────────── -->
<section class="hero">
  <div class="hero-bg"></div>
  <div class="hero-overlay"></div>
  <div class="hero-decoration" aria-hidden="true">
    <div class="hero-decoration__ring hero-decoration__ring--1"></div>
    <div class="hero-decoration__ring hero-decoration__ring--2"></div>
    <div class="hero-decoration__dots"></div>
    <div class="hero-decoration__statue"></div>
  </div>
  <div class="hero-content">
    <div class="hero-eyebrow">Libertarian Candidate for U.S. Senate - Michigan 2026</div>
    <h1>Lydia Christensen</h1>
    <p class="hero-tagline">Michigan's Unchained Voice</p>
    <p class="hero-sub">
      "A republic, if you can keep it."
      <br /><em class="hero-sub__attr">— Benjamin Franklin, 1787</em>
    </p>
    <p class="hero-sub hero-sub--coda">Unchaining Michigan — because Liberty and Justice for All is an American promise.</p>
    <div class="hero-buttons">
      <a routerLink="/volunteer" class="btn-hero-primary">Become a Captain</a>
      <a routerLink="/donate" class="btn-hero-secondary">Donate Now</a>
    </div>
    <div class="hero-stats">
      <div class="hero-stat">
        <span class="hero-stat__num">15,000</span>
        <span class="hero-stat__label">Doors To Knock</span>
      </div>
      <div class="hero-stat__divider"></div>
      <div class="hero-stat">
        <span class="hero-stat__num">Nov 3</span>
        <span class="hero-stat__label">2026 Election Day</span>
      </div>
      <div class="hero-stat__divider"></div>
      <div class="hero-stat">
        <span class="hero-stat__num">$250,000</span>
        <span class="hero-stat__label">Campaign Goal</span>
      </div>
    </div>
  </div>
</section>

<!-- ── COUNTDOWN TIMERS ───────────────────────────────────────────────────── -->
<section class="section-countdowns">
  <div class="container">
    <div class="countdown-grid">
      <div class="countdown-wrap">
        <p class="countdown-label-top">Election Day</p>
        <app-countdown targetDate="2026-11-03T07:00:00" label="Until Election Day" theme="gold"></app-countdown>
        <a routerLink="/volunteer" class="countdown-cta">Become a Captain</a>
      </div>
      <div class="countdown-divider" aria-hidden="true"></div>
      <div class="countdown-wrap">
        <p class="countdown-label-top">Election Day</p>
        <app-countdown targetDate="2026-11-03T07:00:00" label="Until Election Day" theme="green"></app-countdown>
        <a routerLink="/donate" class="countdown-cta countdown-cta--green">Donate Now</a>
      </div>
    </div>
  </div>
</section>

<!-- ── URGENT BANNER ──────────────────────────────────────────────────────── -->
<div class="urgent-banner">
  <span class="urgent-banner__icon">★</span>
  <span>We need volunteers knocking doors to win in November.</span>
  <a routerLink="/volunteer">Become a Constitutional Captain today.</a>
  <span class="urgent-banner__icon">★</span>
</div>

<!-- ── MEET LYDIA ─────────────────────────────────────────────────────────── -->
<section id="about" class="section-about">
  <div class="container">
    <div class="about-grid">
      <div class="about-img-wrap">
        <img src="../../assets/lydia-christensen.jpg" alt="Lydia Christensen" loading="lazy" />
        <div class="about-img-badge">Libertarian • Michigan • 2026</div>
      </div>
      <div class="about-text">
        <div class="section-eyebrow">Meet the Candidate</div>
        <h2>Meet Lydia</h2>
        <p>
  Lydia Christensen is an American politician from Michigan and a candidate for the
  United States Senate in 2026. She is Michigan's Unchained Voice. Her family is from
  Ironwood, MI, but she was born in Ashland, Wisconsin, helicoptered across the border
  because the UP lacked the hospital infrastructure to deliver her safely. She has been
  fighting for the Upper Peninsula ever since returning home.
</p>
        <p>
          As the Libertarian candidate for U.S. Senate, Lydia speaks for all Michiganders free
          from left-right party constraints. Her campaign is about unchaining opportunity,
          protecting clean water, and building unity across our state.
        </p>
        <div class="about-actions">
          <a routerLink="/about" class="btn-primary">Her Full Story</a>
          <a routerLink="/issues" class="btn-outline">Her Platform</a>
          <a routerLink="/merch" class="btn-outline">Campaign Store</a>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ── ISSUES ─────────────────────────────────────────────────────────────── -->
<section class="section-issues">
  <div class="container">
    <div class="section-eyebrow center">Lydia's Platform</div>
    <h2 class="section-title center">Lydia's Vision for Michigan</h2>
    <p class="section-intro">
      Inspired by Michigan's waterfalls, Lydia fights for a state where opportunity
      flows freely for all.
    </p>
    <div class="issues-grid">
      <a
        class="issue-card"
        *ngFor="let issue of issues | slice:0:4"
        [routerLink]="['/issues', issue.id]"
      >
        <span class="issue-card__flag" *ngIf="isOptInFlagIssue(issue)">Opt-In, Not Out</span>
        <div class="issue-card__img" *ngIf="issue.image">
          <img [src]="issue.image" [alt]="issue.title" loading="lazy" />
        </div>
        <div class="issue-card__body">
          <h3>{{ issue.title }}</h3>
          <p>{{ issue.summary || issue.description }}</p>
          <span class="issue-card__cta">Learn More</span>
        </div>
      </a>
    </div>
    <div class="section-link">
      <a routerLink="/issues" class="btn-outline">Explore All Issues</a>
    </div>
  </div>
</section>

<!-- ── TESTIMONIALS ───────────────────────────────────────────────────────── -->
<!-- Uncomment when 3+ real supporter quotes are collected
<section class="section-testimonials">
  <div class="container">
    <div class="section-eyebrow center">Voices from Michigan</div>
    <h2 class="section-title center">What Michiganders Are Saying</h2>
    <app-testimonials></app-testimonials>
  </div>
</section>
-->

<!-- ── LATEST NEWS ────────────────────────────────────────────────────────── -->
<section class="section-news">
  <div class="container">
    <div class="section-eyebrow center">Newsroom</div>
    <h2 class="section-title center">Latest Press Releases</h2>
    <div class="news-grid">
      @for (release of latestReleases; track release.id; let i = $index) {
        <a
          [routerLink]="['/newsroom', getReleaseSlug(release)]"
          class="news-card"
          [class.news-card--featured]="i === 0"
        >
          <div class="news-card__meta">
            <span class="news-tag" [class.news-tag--latest]="i === 0">{{ i === 0 ? 'Latest' : 'Press Release' }}</span>
            <span class="news-card__date">{{ release.date | date:'MMMM d, yyyy' }}</span>
          </div>
          <h3 class="news-card__title">{{ release.title }}</h3>
          <p class="news-card__summary">{{ release.summary }}</p>
          <span class="news-card__cta">Read Full Release →</span>
        </a>
      }
    </div>
    <div class="section-link">
      <a routerLink="/newsroom" class="btn-outline">View All Press Releases</a>
    </div>
  </div>
</section>

<!-- ── SIGNATURE DRIVE CTA ────────────────────────────────────────────────── -->
<section class="section-captain">
  <div class="container">
    <div class="captain-grid">
      <div class="captain-text">
        <div class="section-eyebrow light">Constitutional Captains Program</div>
        <h2>Help Lydia Win Michigan</h2>
        <p>
          As the Libertarian Party nominee, Lydia is automatically on the ballot - now it's
          about turnout. We need 20,000 to 25,000 doors knocked across Michigan
          before <strong>Election Day, November 3, 2026</strong>. Become a Constitutional Captain
          and canvass your community.
        </p>
        <div class="captain-actions">
          <a routerLink="/volunteer" class="btn-hero-primary">Become a Captain</a>
        </div>
      </div>
      <div class="captain-stats">
        <div class="captain-stat-card">
          <div class="captain-stat-card__num">25,000</div>
          <div class="captain-stat-card__label">Minimum doors to knock</div>
        </div>
        <div class="captain-stat-card">
          <div class="captain-stat-card__num">Nov 3</div>
          <div class="captain-stat-card__label">2026 Election Day</div>
        </div>
        <div class="captain-stat-card captain-stat-card--full">
          <div class="captain-stat-card__num">{{ signatures | number }}</div>
          <div class="captain-stat-card__label">Doors knocked so far</div>
          <div class="captain-progress">
            <div
              class="captain-progress__fill"
              [style.width]="(signatures / goal * 100) + '%'"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ── DONATE ─────────────────────────────────────────────────────────────── -->
<section id="donate" class="section-donate">
  <div class="container">
    <div class="section-eyebrow center">Fund the Fight</div>
    <h2 class="section-title center">Amplify Michigan's Unchained Voice</h2>
    <p class="section-intro">
      Your donation powers Lydia's Libertarian campaign to speak for all
      Michiganders, free from establishment strings.
    </p>
    <div class="donate-progress-wrap">
      <div class="donate-progress-bar">
        <div
          class="donate-progress-bar__fill"
          [style.width]="(raised / goalAmount * 100) + '%'"
        ></div>
      </div>
      <div class="donate-progress-labels">
        <span class="donate-raised">${{ raised.toLocaleString() }} raised</span>
        <span class="donate-goal">Goal: ${{ goalAmount.toLocaleString() }}</span>
      </div>
    </div>
    <div class="donate-actions">
      <a routerLink="/donate" class="btn-hero-primary">Donate Now</a>
      <p class="donate-note">Secure donations via Donorbox. Every dollar counts.</p>
    </div>
  </div>
</section>

<!-- ── VOLUNTEER ──────────────────────────────────────────────────────────── -->
<section id="volunteer" class="section-volunteer">
  <div class="container">
    <div class="volunteer-grid">
      <div class="volunteer-text">
        <div class="section-eyebrow light">Get Involved</div>
        <h2>Join the Movement</h2>
        <p>
          This campaign runs entirely on people power. Sign up to volunteer
          and we will reach out with ways you can help Unchain Michigan.
        </p>
        <ul class="volunteer-perks">
          <li>Knock doors as a Constitutional Captain</li>
          <li>Canvass neighborhoods across Michigan</li>
          <li>Help with phone banking and events</li>
          <li>Spread the word on social media</li>
        </ul>
      </div>
      <div class="volunteer-form-wrap">
        <div *ngIf="volunteerSubmitted" class="success-message">
          <div class="success-message__icon">✓</div>
          <p>Thank you for volunteering! We will be in touch soon.</p>
          <button (click)="resetVolunteerForm()" aria-label="Volunteer again">
            Sign Up Again
          </button>
        </div>
        <form
          [formGroup]="volunteerForm"
          (ngSubmit)="onVolunteerSubmit()"
          *ngIf="!volunteerSubmitted"
          class="volunteer-form"
        >
          <div class="form-group">
            <label for="volunteer-name">Full Name</label>
            <input
              id="volunteer-name"
              formControlName="name"
              type="text"
              placeholder="Your full name"
              [attr.disabled]="isSubmitting ? true : null"
              aria-required="true"
            />
            <div *ngIf="volunteerForm.get('name')?.invalid && volunteerForm.get('name')?.touched" class="error">
              Name is required.
            </div>
          </div>
          <div class="form-group">
            <label for="volunteer-email">Email Address</label>
            <input
              id="volunteer-email"
              formControlName="email"
              type="email"
              placeholder="your@email.com"
              [attr.disabled]="isSubmitting ? true : null"
              aria-required="true"
            />
            <div *ngIf="volunteerForm.get('email')?.invalid && volunteerForm.get('email')?.touched" class="error">
              <span *ngIf="volunteerForm.get('email')?.errors?.['required']">Email is required.</span>
              <span *ngIf="volunteerForm.get('email')?.errors?.['email']">Please enter a valid email.</span>
            </div>
          </div>
          <div class="form-group">
            <label for="volunteer-zip">Zip Code</label>
            <input
              id="volunteer-zip"
              formControlName="zip"
              type="text"
              placeholder="5-digit zip code"
              [attr.disabled]="isSubmitting ? true : null"
              aria-required="true"
            />
            <div *ngIf="volunteerForm.get('zip')?.invalid && volunteerForm.get('zip')?.touched" class="error">
              <span *ngIf="volunteerForm.get('zip')?.errors?.['required']">Zip code is required.</span>
              <span *ngIf="volunteerForm.get('zip')?.errors?.['pattern']">Zip code must be 5 digits.</span>
            </div>
          </div>
          <div class="form-group">
            <label for="volunteer-role">How Can You Help? <span class="optional">(optional)</span></label>
            <input
              id="volunteer-role"
              formControlName="role"
              type="text"
              placeholder="e.g. Canvassing, Phone Banking, Social Media"
              [attr.disabled]="isSubmitting ? true : null"
            />
          </div>
          <button
            type="submit"
            [disabled]="volunteerForm.invalid || isSubmitting"
            aria-label="Join as a volunteer"
          >
            {{ isSubmitting ? 'Sending...' : 'Join the Team' }}
          </button>
          <div *ngIf="errorMessage" class="error">{{ errorMessage }}</div>
        </form>
      </div>
    </div>
  </div>
</section>
